
import ListPurchase from './ListPurchase'

export default ListPurchase